import {request} from "@/shared/api/request";

export const sendPension = (payload) => {
    return request({ url: 'proactive/signxml/', method: 'POST', data: payload })
}